import styled from "styled-components";
import { ImageData } from "../../utils/image/image-data";
import { LargeLocationImagePreviewLargeCard } from "../card/LargeLocationImagePreviewCard";

interface Props {
  imageData: ImageData[];
}

export const LargeLocationImagePreview: React.FC<Props> = ({ imageData }) => {
  return (
    <LargeLocationImagePreviewContainer>
      {imageData.map((image, index) => (
        <LargeLocationImagePreviewLargeCard imageData={image} index={index} />
      ))}
    </LargeLocationImagePreviewContainer>
  );
};

const LargeLocationImagePreviewContainer = styled.div`
  margin-top: 1rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: center;
  align-items: center;
  grid-gap: 0.813rem;
`;
